'use client'

import { AchieveLink } from 'components/AchieveLink/AchieveLink'
import { Typography } from 'components/Contentful'
import { BLOCKS } from '@contentful/rich-text-types'
import { _get } from 'utils/shared'

function AboutUsLeadershipBody({ content }) {
  if (!content?.linkHref) return null

  const linkText = content?.linkText?.json

  return (
    <div
      className="w-full mt-8 lg:mt-12 max-w-[808px] mx-auto text-center"
      data-testid="about-us-leadership-body"
    >
      <AchieveLink
        href={content.linkHref}
        withNextLink
        underline="hover"
        className="inline-flex text-blue-500"
        track={{
          list_name: 'About Us Leadership',
          click_id: _get(linkText, 'content[0].content[0].value'),
          click_text: _get(linkText, 'content[0].content[0].value'),
          nav_link_section: 'About Us Leadership',
          track_event: 'page_nav_click',
          event_action: 'link_click',
          event_type: 'link_click',
          ...content?.event,
        }}
        data-testid="about-us-leadership-link"
      >
        <Typography
          content={linkText}
          variantOverride={{ [BLOCKS.PARAGRAPH]: 'bodySm lg:bodyMd' }}
          className="font-bold"
        />
      </AchieveLink>
    </div>
  )
}

export { AboutUsLeadershipBody }
export default AboutUsLeadershipBody
